import { api } from '../services/api';
import {
  FETCH_LOGS_PATH,
  FETCH_LOG_STATS_PATH,
  CLEANUP_LOGS_PATH,
} from '../services/path';
import { showErrorMessage, showSuccessMessage } from '../utils/utils';
import {
  FETCH_LOGS,
  FETCH_LOG_STATS,
  CLEANUP_LOGS,
  FETCH_LOG_BY_ID
} from './types';

export const fetchLogs = (perPage, offSet, filters = {}) => async (dispatch) => {
  // Filtrar campos vacíos
  const cleanFilters = Object.keys(filters).reduce((acc, key) => {
    if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
      acc[key] = filters[key];
    }
    return acc;
  }, {});
  
  const queryParams = new URLSearchParams({
    perPage,
    offSet,
    ...cleanFilters
  });
  
  // Despachar PENDING
  dispatch({
    type: `${FETCH_LOGS}_PENDING`
  });
  
  try {
    const response = await api.get(`${FETCH_LOGS_PATH}?${queryParams.toString()}`);
    
    dispatch({
      type: `${FETCH_LOGS}_FULFILLED`,
      payload: response
    });
    
    return response;
  } catch (error) {
    console.error('Action - fetchLogs error:', error);
    
    dispatch({
      type: `${FETCH_LOGS}_REJECTED`,
      payload: error
    });
    
    throw error;
  }
};

export const fetchLogById = (id) => (dispatch) => dispatch({
  type: FETCH_LOG_BY_ID,
  promise: api.get(`${FETCH_LOGS_PATH}/${id}`)
});

export const fetchLogStats = (filters = {}) => async (dispatch) => {
  const queryParams = new URLSearchParams(filters);
  
  dispatch({
    type: `${FETCH_LOG_STATS}_PENDING`
  });
  
  try {
    const response = await api.get(`${FETCH_LOG_STATS_PATH}?${queryParams.toString()}`);
    
    dispatch({
      type: `${FETCH_LOG_STATS}_FULFILLED`,
      payload: response
    });
    
    return response;
  } catch (error) {
    console.error('fetchLogStats error:', error);
    
    dispatch({
      type: `${FETCH_LOG_STATS}_REJECTED`,
      payload: error
    });
    
    throw error;
  }
};

export const cleanupOldLogs = (dias = 30, callback) => (dispatch) => dispatch({
  type: CLEANUP_LOGS,
  promise: api.delete(`${CLEANUP_LOGS_PATH}?dias=${dias}`),
  meta: {
    onSuccess: () => {
      callback && callback();
      showSuccessMessage(
        'Logs antiguos eliminados correctamente',
        dispatch
      );
    },
    onFailure: (res) => {
      showErrorMessage(
        res.response?.data?.message || 'Error al eliminar logs antiguos',
        dispatch
      );
    },
  },
});
